
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUserRoles } from '@/hooks/useUserRoles';
import { TeamEquipmentDialog } from './TeamEquipmentDialog';

interface TeamEquipmentCostProps {
  teamId: string;
}

export const TeamEquipmentCost = ({ teamId }: TeamEquipmentCostProps) => {
  const { isAdmin } = useUserRoles();
  
  const { data: equipmentData, isLoading } = useQuery({
    queryKey: ['team-equipment-cost', teamId],
    queryFn: async () => {
      // TODO: Equipment tables not yet created - temporarily disabled
      return { totalCost: 0 };
    },
    enabled: isAdmin
  });
  
  if (!isAdmin || isLoading || !equipmentData) return null;
  
  return <TeamEquipmentDialog teamId={teamId} />;
};
